import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import useStyles from './styles';

const DialogAlert = ({isOpen, subject, message, subscribeUserToPush, unSubscribeUserToPush}) => {
    const classes = useStyles();
    
	return (
		<Dialog open={isOpen} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">{subject}</DialogTitle>
			<DialogContent classes={{ root: classes.dialogContent }}>
                <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: message }} />
			</DialogContent>
            <DialogActions classes={{ root: classes.dialogActions }}>
                <Button 
                    variant="contained" 
                    size="large" 
                    data-cy="dialog-allow-notification-no"
                    id="dialog-allow-notification-no"
                    classes={{root: classes.cancelButton}}
                    onClick={() => unSubscribeUserToPush()}
                    autoFocus>
                    { 'Não' }
                </Button>
                <Button
                    color="primary" 
                    variant="contained" 
                    data-cy="dialog-allow-notification-yes"
                    id="dialog-allow-notification-yes"
                    autoFocus 
                    size="large"
                    classes={{root: classes.actionButton}}
					onClick={() => subscribeUserToPush()}
					>
                    {'SIM'}
                </Button>
            </DialogActions>
		</Dialog>
	);
};

export default DialogAlert;
